<template>
  <div class="d-flex flex-column justify-content-start mt-5">
    <div>
      <div class="text-center">
        <h1 class="grey--text">
          404
        </h1>
      </div>


      <div class="flex-grow-1 text-center">
        <v-container fluid>
          <v-row justify="center">

            <v-col cols="5" md="2" sm="2">
              <v-btn outlined href="/main/dashboard" dense color="primary">Dashboard</v-btn>
            </v-col>

            <v-col cols="5" md="2" sm="2">
              <v-btn outlined dense color="primary">Previous Page</v-btn>
            </v-col>
          </v-row>

        </v-container>
      </div>
    </div>

  </div>
</template>


<script>



export default {
  name: "NotFound",

}
</script>

<style lang="css" scoped>
h1 {
  font-size: 10.50rem;
}
</style>